// extracted by mini-css-extract-plugin
module.exports = {"slider":"styles-module--slider--1YDev","wrap":"styles-module--wrap--2pry5"};